<section class="jumbotron">
  <div class="container position-relative">
    <div class="jumbotron-content text-white text-center">
      <h1 class="font-weight-bolder text-title-header">{{'header.industrial' | translate}}</h1>
      <span class="italic-title"><i>Smart Industry</i> </span> <br>
      <img src="../../../../assets/img/SOLUCIÓN/INDUSTRIAL/01.svg" alt="">
    </div>
  </div>
</section>
<section class="bg-green-qaira">
  <div class="container py-4 text-center text-white">
    <p class="p-subtitle text-center">{{'solution.smart_industry_text' | translate}}</p>
  </div>
</section>


<section>
  <div class="container py-4">
    <p class="text-center mb-5 p-subtitle">{{'solution.text' | translate}}</p>
    <div class="row p-0 m-0 justify-content-md-center">
      <div class="col-lg-4"></div>
      <div class="col-lg-4">
        <div class="item-img-hover" style="background: url(../../../assets/img/SOLUCIÓN/INDUSTRIAL/emesent.png);">
          <div class="content-item-img">
            <a class="btn custom-cta" [routerLink]="['/solucion/industrial/emesent']">{{'app.see_more' | translate}}</a>
          </div>
        </div>
        <div class="item-img-text text-center pt-3">
          <img src="../../../../assets/img/SOLUCIÓN/INDUSTRIAL/emesent_logo.png" alt="">
          <!-- <p>{{'header.environment' | translate}}</p> -->
        </div>
      </div>
      <div class="col-lg-4"></div>      
    </div>
  </div>
</section>
<section class="section-land">
  <div class="container text-center text-white">
    <h1>{{'app.questions' | translate}}</h1>
    <p>{{'app.questions_sub' | translate}}</p>
      <a class="btn custom-cta mb-5" [routerLink]="['/contacto']">{{'app.contact_us' | translate}}</a>
  </div>
</section>